import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2, ShieldCheck, AlertTriangle } from 'lucide-react';
import { API } from '../lib/constants';

const MagicLink = () => {
  const navigate = useNavigate();
  const started = useRef(false);
  const [status, setStatus] = useState('loading'); // loading | error

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const token = new URLSearchParams(window.location.search).get('token');
    // Strip the token from the address bar / history immediately.
    window.history.replaceState({}, document.title, '/magic');

    if (!token) { setStatus('error'); return; }

    (async () => {
      try {
        const res = await axios.post(`${API}/api/auth/magic`, { token }, { withCredentials: true });
        if (res.data?.success) {
          localStorage.setItem('userId', res.data.user_id);
          localStorage.setItem('userEmail', res.data.email);
          if (res.data.username) localStorage.setItem('username', res.data.username);
          if (res.data.is_admin) localStorage.setItem('isAdmin', 'true');
          navigate(res.data.is_admin && !res.data.username ? '/admin' : '/dashboard', { replace: true });
        } else {
          setStatus('error');
        }
      } catch {
        setStatus('error');
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4" data-testid="magic-link-page">
      <div className="w-full max-w-md text-center">
        <img src="/offersz-lockup.png" alt="Offersz" className="w-40 h-auto mx-auto mb-8" />
        {status === 'loading' && (
          <div data-testid="magic-link-loading">
            <Loader2 className="h-10 w-10 animate-spin mx-auto mb-5 text-[#0F5132]" />
            <h1 className="text-2xl font-black mb-2 flex items-center justify-center gap-2">
              <ShieldCheck className="h-6 w-6 text-[#0F5132]" /> Signing you in…
            </h1>
            <p className="text-white/50">Hang tight, taking you to your profile.</p>
          </div>
        )}
        {status === 'error' && (
          <div data-testid="magic-link-error">
            <AlertTriangle className="h-10 w-10 mx-auto mb-5 text-amber-400" />
            <h1 className="text-2xl font-black mb-2">That link didn't work</h1>
            <p className="text-white/50 mb-7">It may have expired or already been used. Get a fresh sign-in link or enter your code instead.</p>
            <button
              onClick={() => navigate('/verify')}
              data-testid="magic-link-fallback-btn"
              className="w-full bg-[#0F5132] hover:bg-[#0B3B24] text-white font-bold h-12 rounded-xl text-lg transition-colors"
            >
              Email me a new link
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MagicLink;
